export const templatePath = () => '/service/report/service/templates/LearningProjectUnitSummaryByUsers.docx';
